import { CarBrakeAbsIcon } from './CarBrakeAbsIcon';

/**
 * author: Michael Irigoyen
 * id 170D1972-AFA7-417C-BCC4-B07689D8B6F4
 * name car-brake-abs
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/car-brake-abs.svg
 * tags
 * - Automotive 
 */
export const AntiLockBrakingSystemIcon = CarBrakeAbsIcon;
export default AntiLockBrakingSystemIcon